
/* ============================== src/components/EntitySelectDropdown.jsx ============================== */
// src/components/EntitySelectDropdown.jsx
import { useMemo } from "react";
import { Select } from "./Select";
import { optionsFromList } from "../utils/selectOptions";

export function EntitySelectDropdown({
  items = [],
  value,
  onChange,
  getOptionValue = (item) => item.id,
  getOptionLabel = (item) => item.name || item.title || item.code || "",
  allLabel = "Все",
  placeholder = "Выберите...",
  searchable = true,
  disabled = false,
  className = "",
  onSearch, // <-- Добавили проп
}) {
  const options = useMemo(
    () =>
      optionsFromList(items, allLabel, (item) => ({
        value: getOptionValue(item),
        label: getOptionLabel(item),
      })),
    [items, allLabel, getOptionValue, getOptionLabel],
  );

  return (
    <Select
      className={`filter-select ${className}`.trim()}
      value={value}
      onChange={onChange}
      options={options}
      searchable={searchable}
      disabled={disabled}
      placeholder={placeholder}
      onSearch={onSearch} // <-- Пробрасываем в Select
    />
  );
}
